import { UNFAVORITE_CLUB, UPDATE_FAVORITE_CLUB_PLAYERS_COUNT } from "../actions";

export const initialState = {} as { [key: string]: number };

export type ClubPlayerCountsState = typeof initialState;

export default function(state = initialState, action) {
	switch (action.type) {
		/*
		case UNFAVORITE_CLUB: {
			let favorites = state.favorites;
			if (favorites === null) {
				return state;
			}

			for (let i = 0; i < favorites.length; i++) {
				if (favorites[i].clubInfo.clubId === action.club.clubInfo.clubId) {
					favorites.splice(i, 1);
				}
			}

			return { favorites: [...favorites] };
		}
        */

		case UPDATE_FAVORITE_CLUB_PLAYERS_COUNT: {
			const { clubId, playersCount } = action;
			state[clubId] = playersCount;
			return { ...state };
		}

		default:
			return state;
	}
}
